import { render, staticRenderFns } from "./GroupChatComponent.vue?vue&type=template&id=6de0c8da&scoped=true&v-if=entitiesLoaded&"
import script from "./GroupChatComponent.vue?vue&type=script&lang=js&"
export * from "./GroupChatComponent.vue?vue&type=script&lang=js&"
import style0 from "./GroupChatComponent.vue?vue&type=style&index=0&id=6de0c8da&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de0c8da",
  null
  
)

export default component.exports